import { IntlShape } from 'react-intl';
import { useIntl } from 'react-intl';
import {
    ssnNotReqdReasons,
    ssnOptions,
} from '../constants/members/members.constants';
// Utility function to translate options
export const translateOptions = (
    options: { value: string; text: string }[],
    intl: IntlShape,
) => {
    return options.map((option) => ({
        ...option,
        text: intl.formatMessage({ id: option.text }),
    }));
};
const useGetTranslatedOptions = () => {
    const intl = useIntl();
    // Translate the ssnOptions and ssnNotReqdReasons arrays
    const translatedSsnOptions = translateOptions(ssnOptions, intl);
    const translatedSsnReasons = translateOptions(ssnNotReqdReasons, intl);
    return { translatedSsnOptions, translatedSsnReasons };
};
export default useGetTranslatedOptions;
